module.exports = __webpack_public_path__ + "static/media/PIX.cdcfdc24.png";